module.exports = __webpack_public_path__ + "img/ic_supervision_publicity1.e25ccbdd.png";